import _ from 'lodash'
import React, { useState, useEffect , startTransition} from 'react'
import styled from 'styled-components'
import { getAccountLanguage, requestTranslation } from '@futures-platform/i18n'
import { Checkbox, PhenomenonType, Tag, modalStyles, Modal } from '@futures-platform/ui'
import { useTags } from '@futures-platform/hooks'
// import Tag from "./Ui_package/Tag_sangre_ui"
import { capitalizeFirstLetter } from '../helpers'
import { InfoCircle } from '@styled-icons/boxicons-regular'
import { fetcher } from '../helpers/fetcher'
import { getUserId } from '@futures-platform/connectors/session'
import { getAssessmentStatusStorageKey } from '../helpers/assessmentStatus'

export const Filters = props => {
    const renderPhenomenaType = phenomenaType => {
        const {groupType, id, alias, title, style} = phenomenaType
        const {activeFilter, setActiveFilter} = props

        return (
            <StateContainer key={id}>
                <PhenomenaState>
                    <PhenomenonType type={alias} size={15} fill = {style ? style.color : null} />
                </PhenomenaState>
                <Checkbox
                    label={groupType ? title : requestTranslation(alias)}
                    value={id}
                    checked={_.find(activeFilter, filter => filter.id === id)}
                    onChange={() => setActiveFilter(phenomenaType)}
                    className='phenomena-checkbox'
                />
            </StateContainer>
        )
    }

    const renderTags = tags => {
        const {language, activeTagFilter, setActiveTagFilter} = props

        return (
            <div>
                {!!(_.isArray(tags) && tags.length) && (
                    <div>
                        <div className='d-flex flex-row flex-wrap'>
                            {tags?.sort(function (a, b) {
                              const textA = !!a.label[language] ? a.label[language].toUpperCase(): a.label.toUpperCase();
                              const textB = !!b.label[language] ? b.label[language].toUpperCase(): b.label.toUpperCase();
                              return textA < textB ? -1 : textA > textB ? 1 : 0;
                            })?.map((tag, index) => {
                              const tagUriSplit = tag?.uri?.split("/")
                              const isFPTags= tagUriSplit[1] === "theme" ? true : false
                                return (
                                    <OptionsListItem key={index} style={{padding: '0 5px'}}>
                                        <Tag
                                            isFPTags={isFPTags}
                                            isNotFilter={false}
                                            label={capitalizeFirstLetter(tag.label[language] || tag.label)}
                                            active={_.find(activeTagFilter, filter => filter === tag.uri)}
                                            onClick={() => setActiveTagFilter(tag.uri)}
                                        />
                                    </OptionsListItem>
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const renderLoading = () => <div>{requestTranslation('loading')}</div>

    const {
        filtersVisible,
        phenomenaTypes,
        toggleFilter,
        resetFilters,
        activeFilter,
        activeTagFilter,
        group,
        hideInfoButton = false,
        showAssessmentStatus,
        setAssessmentStatusVisible,
        votingOn,
        ratingsOn,
        commentsOn,
        radarId,
    } = props

    const {tags} = useTags(group && group.id)
    let [fpTags, groupTags] = tags
    const activeFilters = [...activeFilter, ...activeTagFilter].length
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

    // Restore showAssessmentStatus from localStorage on mount (per-user/group/radar preference)
    useEffect(() => {
        if (!radarId || !group?.id) return
        try {
            const userId = getUserId()
            const stored = localStorage.getItem(getAssessmentStatusStorageKey(userId, group.id, radarId))
            if (stored === 'true' && setAssessmentStatusVisible) {
                setAssessmentStatusVisible(true)
            } else if (stored !== 'true' && setAssessmentStatusVisible) {
                setAssessmentStatusVisible(false)
            }
        } catch (e) {
            // localStorage not available — ignore, use Redux default
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [radarId, group?.id])

    // Handler: toggle assessment status + persist to localStorage
    const handleAssessmentStatusChange = () => {
        const newValue = !showAssessmentStatus
        if (setAssessmentStatusVisible) setAssessmentStatusVisible(newValue)
        try {
            const userId = getUserId()
            localStorage.setItem(getAssessmentStatusStorageKey(userId, group?.id, radarId), String(newValue))
        } catch (e) {
            // localStorage not available — ignore
        }
    }

    // Show assessment status filter only when at least one collab tool is enabled (spec §1.2)
    const showAssessmentStatusFilter = !!(votingOn || ratingsOn || commentsOn)

    return (
      <div>
        <div style={{ zIndex: 2, position: 'absolute', left: '0px', bottom: '0px', position: 'fixed' }}>

            <FiltersButton
              className={`btn-round btn-lg d-flex align-items-center justify-content-center ${activeFilters ? '' : 'inactive'}`}
              style={{ marginLeft: '15px', marginBottom: '10px'}}
              onClick={toggleFilter}
            >
                <i className='material-icons' style={{transform: 'rotate(-90deg)', fontWeight: 'bold'}}>tune</i>
                {!!activeFilters && (
                  <ActiveFiltersIndicator
                      className='d-flex justify-content-center align-items-center'>{activeFilters}</ActiveFiltersIndicator>
                )}
            </FiltersButton>
            
            {!hideInfoButton && <div className='radar-nav' id='radar-nav-bottomleft' style={{zIndex: 1, position: 'relative', left: 0, bottom: '0px'}}>
              <FiltersButton
                className={`btn-round btn-lg d-flex align-items-center justify-content-center ${activeFilters ? '' : 'inactive'}`}
                style={{ marginBottom: '10px'}}
                onClick={() => setIsInfoModalOpen(true)}
              >
                <span className='af-custom-info'/>
                <span className='sr-only'>Info</span>
              </FiltersButton>
            </div> }
            
            {filtersVisible && (
                <LegendContainer className='pb-4'>
                    <button className={'btn-close-modal'} onClick={toggleFilter}>
                        <i className='material-icons'>close</i>
                    </button>
                    <Container>
                        <h3 className='radar-widget-title mb-0'>{requestTranslation('filterPhenomena')}</h3>
                    </Container>
                    {/* Assessment status filter – spec §1.2: above BY TAG, visible when any collab tool is enabled */}
                    {showAssessmentStatusFilter && (
                        <Container>
                            <AssessmentStateContainer>
                                <Checkbox
                                    label={requestTranslation('showAssessmentStatus')}
                                    checked={!!showAssessmentStatus}
                                    onChange={handleAssessmentStatusChange}
                                    className='phenomena-checkbox'
                                />
                            </AssessmentStateContainer>
                        </Container>
                    )}
                    <Container style={{padding: '15px 10px'}}>
                        <h5 className='mb-2 mt-1 ml-2'>{requestTranslation('filterByTag')}</h5>
                        {groupTags ? renderTags([...groupTags, ...fpTags]) : renderTags([...fpTags])}
                    </Container>
                    <Container>
                        <h5 className='mb-3 mt-1'>{requestTranslation('filterByType')}</h5>
                        {phenomenaTypes && phenomenaTypes.length ? _.map(phenomenaTypes, renderPhenomenaType) : renderLoading}
                    </Container>
                    <Container style={{borderBottom: 'none'}}>
                        <button className='btn btn-outline-secondary w-100' onClick={resetFilters}>
                            {requestTranslation('resetFilters')}
                        </button>
                    </Container>
                </LegendContainer>
            )}
        </div>
        <Modal
          wrapperClassname={"info-modal"}
          isOpen={isInfoModalOpen}
          onRequestClose={() => setIsInfoModalOpen(false)}
          style={modalStyles}
        >
          <InfoModal>
            <div className="confirmation-modal-content ">
              <div
                className="modal-form-section modal-form-header radar-info-content"
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <InformationIcon />
                  <h2
                    style={{
                      marginLeft: '20px',
                      marginBottom: '0',
                      fontSize: '1.3125rem',
                      fontWeight: 700,
                      fontFamily: 'L10',
                    }}
                  >
                    {requestTranslation('infoModalTitle')}
                  </h2>
                </div>
                <div
                  className='info-modal-content'
                >
                  <p dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentDescription')}}></p>
                  <p dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentPhenomena')}}></p>
                  <table className='info-modal-content-phenomena'>
                    <tbody>
                      <tr>
                        <td>
                          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 18C30 24.6274 24.6274 30 18 30C11.3726 30 6 24.6274 6 18C6 11.3726 11.3726 6 18 6C24.6274 6 30 11.3726 30 18Z" fill="#00CA8D"/>
                          </svg>
                        </td>
                        <td>
                          <div dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentStrengthening')}}></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 18C30 24.6274 24.6274 30 18 30C11.3726 30 6 24.6274 6 18C6 11.3726 11.3726 6 18 6C24.6274 6 30 11.3726 30 18Z" fill="#016998"/>
                          </svg>
                        </td>
                        <td>
                          <div dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentEstablished')}}></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 18C30 24.6274 24.6274 30 18 30C11.3726 30 6 24.6274 6 18C6 11.3726 11.3726 6 18 6C24.6274 6 30 11.3726 30 18Z" fill="#0098FF"/>
                          </svg>
                        </td>
                        <td>
                          <div dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentWeakening')}}></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 18C30 24.6274 24.6274 30 18 30C11.3726 30 6 24.6274 6 18C6 11.3726 11.3726 6 18 6C24.6274 6 30 11.3726 30 18Z" fill="#A8A8A8"/>
                          </svg>
                        </td>
                        <td>
                          <div dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentWeakSignal')}}></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 18C30 24.6274 24.6274 30 18 30C11.3726 30 6 24.6274 6 18C6 11.3726 11.3726 6 18 6C24.6274 6 30 11.3726 30 18Z" fill="#E95757"/>
                          </svg>
                        </td>
                        <td>
                          <div dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentWildCard')}}></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="18" cy="18" r="16" fill="#00CA8D"/>
                            <circle cx="18" cy="18" r="12.9524" fill="white"/>
                            <path d="M29.4286 18C29.4286 24.3118 24.3118 29.4286 18 29.4286C11.6882 29.4286 6.57141 24.3118 6.57141 18C6.57141 11.6882 11.6882 6.57144 18 6.57144C24.3118 6.57144 29.4286 11.6882 29.4286 18Z" fill="#00CA8D"/>
                          </svg>
                        </td>
                        <td>
                          <div dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentSummary')}}></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="18" cy="18" r="10.5" fill="#00CA8D"/>
                            <circle cx="18" cy="18" r="8" fill="white"/>
                          </svg>
                        </td>
                        <td>
                          <div dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentNoType')}}></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentTimeRanges')}}></p>
                  <p dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentSectors')}}></p>
                  <p dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentCollaboration')}}></p>
                  <p dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentEditingAndSharing')}}></p>
                  <p dangerouslySetInnerHTML={{__html: requestTranslation('infoModalContentCTA')}}></p>

                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '30px',
                  }}
                >
                  <button
                    className="btn btn-lg btn-primary"
                    onClick={() => {
                      setIsInfoModalOpen(false);
                    }}
                  >
                    {requestTranslation("GotItBtn")}
                  </button>
                </div>
              </div>
            </div>
          </InfoModal>
        </Modal>
      </div>
    )
}

const OptionsListItem = styled.div`
    padding: 0 12px;
    display: flex;
    align-items: center;
    margin-top: 8px;
`

const LegendContainer = styled.div`
  width: 270px;
  position: absolute;
  background-color: #F2F4F4;
  left: 37px;
  bottom: 18px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
`

const FiltersButton = styled.button`
  bottom: 65px;
  left: 15px;
  /*background-color: rgb(242,244,244) !important;*/


  &.inactive {
    background-color: transparent !important;
    border: 2px solid white;

    i {
      color: white;
    }
  }

  &:hover {
    background-color: #006998 !important;
  }
`

const Container = styled.div`
  padding: 15px 17px;
  border-bottom: 1px solid #e9e9ea;
  max-height: 260px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 8px;
    margin-right: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(194, 208, 215);
    border-radius: 20px;
  }

  ::-webkit-scrollbar-track {
    background: white;
    border-radius: 20px;
  }
`

const StateContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  min-height: 25px;
  align-items: center;
  position: relative;
`

const PhenomenaState = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  position: absolute;
  z-index: 10;
  left: 27px;
`

// Same visual rhythm as phen-type rows:
// - icon (PhenomenaState) sits at left: 27px in StateContainer; text at 53px (gap = 11px)
// - here the checkbox square IS the "icon": push it to x=27 (margin-left: 27px),
//   reduce padding-left to 26px so text still lands at 27+26=53px (aligned with phen labels)
// Two-class specificity beats .phenomena-checkbox (one class), even with !important.
const AssessmentStateContainer = styled(StateContainer)`
  .fp-checkbox {
    padding-left: 30px !important;
  }
`

const ActiveFiltersIndicator = styled.div`
  width: 13px;
  height: 13px;
  background-color: white;
  font-size: 9px;
  position: absolute;
  color: black;
  top: 0px;
  left: 0px;
  border-radius: 50%;
`

const InfoModal = styled.div`
  padding: 20px;
  
  .group-select {
    margin-bottom: 15px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .upload-section {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    margin: 20px 0;
    transition: border-color 0.3s ease;
    
    &.drag-active {
      border-color: #007bff;
      background: rgba(0,123,255,0.05);
    }
  }

  .drop-zone {
    p {
      margin-bottom: 10px;
      color: #666;
    }
  }

  .selected-files {
    margin-top: 15px;
    text-align: left;
    
    .file-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 10px;
      background: #f8f9fa;
      border-radius: 4px;
      margin-bottom: 5px;
      
      button {
        padding: 0 5px;
        font-size: 20px;
        color: #dc3545;
        
        &:hover {
          color: #c82333;
        }
      }
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
`;

const InformationIcon = styled(InfoCircle)`
  background-color: white;
  color: #00c3ff;
  width: 45px;
  height: 45px;
`